import { get } from '@bigyouth/base'
import scrollManager from '../utils/scrollManager'
import { srHide, srShow } from '../utils/srVisibility'

export default {
  name: 'cart-delete',

  selectedModal: null,

  ui: {
    modal: '[js-cart-delete-modal]',
    'openModal[]': '[js-cart-delete-open-modal]',
    'closeModal[]': '[js-cart-delete-close-modal]',
  },

  events: [
    {
      target: 'openModal',
      on: 'click',
      handle (e) {
        e.preventDefault()
        let target = e.target

        if (target.tagName === 'svg') {
          target = target.parentNode
        } else if (target.tagName === 'use') {
          target = target.parentNode.parentNode
        }

        const id = target.getAttribute('data-product')

        this.selectedModal = get(`[js-cart-delete-modal="${id}"]`)
        srShow(this.selectedModal)

        scrollManager.stop()
      },
    },
    {
      target: 'closeModal',
      on: 'click',
      handle (e) {
        e.preventDefault()
        srHide(this.selectedModal)
        scrollManager.restart()
        this.selectedModal = null
      },
    },
  ],

  componentDidMount () {
    // Move modal to modals layer
    const modalsLayer = get('.modals')
    modalsLayer.appendChild(this.ui.modal)
  },
}
